import { RetryIcon, ServerFaultIcon } from '@shared/ui/icons';
import { GaugeIcon } from '@shared/ui/icons/nav';

import { SystemLinkAction, SystemReloadAction } from '../_shared/components';
import { ErrorPage } from '../_shared/ErrorPage';
import { copy } from './copy';

/**
 * The fall-through surface for a request the service did not answer.
 *
 * The shell is the not-found page's, character for character; the block differs
 * in icon, colour, text, and actions — never in a number on screen.
 *
 * The icon takes the failure colour, because the failure colour is reserved for
 * destruction and failure while the warning colour carries reversible risk and
 * guidance, and a server error is a fault. Colour is not the only signal: the
 * heading and the paragraph both say so in words.
 *
 * **No «report the defect» line**, on purpose, and this is where the console
 * departs from the same page on the two sibling hosts. Both siblings' report
 * entries raise a case into *this* console's own queue, and the operator is the
 * party who works that queue rather than the one who submits to it. Linking the
 * queue here would ask an operator to open their own inbox to find a report
 * nobody wrote.
 */
export function ServerErrorPage() {
  return (
    <ErrorPage
      kind="server"
      documentTitle={copy.documentTitle}
      icon={<ServerFaultIcon />}
      heading={copy.heading}
      body={copy.body}
      actions={
        <>
          <SystemReloadAction icon={<RetryIcon />}>{copy.actions.retry}</SystemReloadAction>
          <SystemLinkAction to="/" intent="secondary" icon={<GaugeIcon />}>
            {copy.actions.home}
          </SystemLinkAction>
        </>
      }
    />
  );
}
